import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function ImpressumPage() {
  return (
    <div className="min-h-screen pt-28 pb-16" data-testid="impressum-page">
      <div className="max-w-3xl mx-auto px-6 sm:px-8 lg:px-12">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-slate-500 hover:text-slate-900 transition-colors mb-8" data-testid="impressum-back-link">
          <ArrowLeft size={16} />
          Zurück zur Startseite
        </Link>

        <div className="bg-white/60 backdrop-blur-2xl border border-white/80 shadow-[0_8px_32px_rgba(0,0,0,0.04)] rounded-3xl p-8 lg:p-12">
          <h1 className="text-4xl sm:text-5xl font-light tracking-tight text-slate-900 font-['Outfit'] mb-10">Impressum</h1>

          <div className="space-y-8 text-sm leading-relaxed text-slate-600">
            <div>
              <h2 className="text-lg font-semibold text-slate-900 font-['Outfit'] mb-3">Angaben gemäß § 5 TMG</h2>
              <p>
                <strong className="text-slate-800">JF-NEXUS</strong><br />
                Jens Mäder & Florian Fuß GbR<br />
                Fehnstr. 16<br />
                96317 Kronach
              </p>
            </div>

            <div>
              <h2 className="text-lg font-semibold text-slate-900 font-['Outfit'] mb-3">Kontakt</h2>
              <p>
                E-Mail:{' '}
                <a href="mailto:info@jf-nexus.de" className="text-purple-600 hover:text-purple-700 transition-colors">
                  info@jf-nexus.de
                </a>
              </p>
            </div>

            <div>
              <h2 className="text-lg font-semibold text-slate-900 font-['Outfit'] mb-3">Umsatzsteuer-ID</h2>
              <p>
                Umsatzsteueridentifikationsnummer gemäß § 27a Umsatzsteuergesetz:<br />
                DE462288018
              </p>
            </div>

            <div>
              <h2 className="text-lg font-semibold text-slate-900 font-['Outfit'] mb-3">Vertretungsberechtigte Gesellschafter</h2>
              <p>Jens Mäder, Florian Fuß</p>
            </div>

            <div>
              <h2 className="text-lg font-semibold text-slate-900 font-['Outfit'] mb-3">Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
              <p>Jens Mäder & Florian Fuß<br />Fehnstr. 16<br />96317 Kronach</p>
            </div>

            <div>
              <h2 className="text-lg font-semibold text-slate-900 font-['Outfit'] mb-3">EU-Streitschlichtung</h2>
              <p>
                Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{' '}
                <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-purple-600 hover:text-purple-700 transition-colors break-all">
                  https://ec.europa.eu/consumers/odr/
                </a>
                <br />Unsere E-Mail-Adresse finden Sie oben im Impressum.
              </p>
            </div>

            <div>
              <h2 className="text-lg font-semibold text-slate-900 font-['Outfit'] mb-3">Verbraucherstreitbeilegung / Universalschlichtungsstelle</h2>
              <p>
                Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
                Verbraucherschlichtungsstelle teilzunehmen.
              </p>
            </div>

            <div>
              <h2 className="text-lg font-semibold text-slate-900 font-['Outfit'] mb-3">Haftung für Inhalte</h2>
              <p>
                Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten
                nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als
                Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde
                Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige
                Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen
                nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch
                erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich.
              </p>
            </div>

            <div>
              <h2 className="text-lg font-semibold text-slate-900 font-['Outfit'] mb-3">Haftung für Links</h2>
              <p>
                Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen
                Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen.
                Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der
                Seiten verantwortlich.
              </p>
            </div>

            <div>
              <h2 className="text-lg font-semibold text-slate-900 font-['Outfit'] mb-3">Urheberrecht</h2>
              <p>
                Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen
                dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art
                der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen
                Zustimmung des jeweiligen Autors bzw. Erstellers.
              </p>
            </div>
          </div>

          {/* Phone number placed very discreetly as required */}
          <div className="mt-12 pt-6 border-t border-slate-100">
            <p className="text-[10px] text-slate-300 leading-relaxed">
              Gesellschaftssitz Fehnstr. 16, 96317 Kronach. Telefonische Erreichbarkeit gemäß gesetzlicher Anforderung: 01739187404.
              Bevorzugte Kontaktaufnahme bitte per E-Mail an info@jf-nexus.de.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
